import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { NeuCard } from "../../components/neu/Neu";
import { customSalaryReport, salaryReport } from "../../api/payroll";
import { SalaryDetails } from "./SalaryDetails";

// كشوفات الشهر في لوحة الرواتب: نفس أعمدة تقرير الرواتب التفصيلي (بما فيها الراتب الأساسي).
export const MonthSlipsCard = ({ filters }) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const [data, setData] = useState(null);
  const custom = Boolean(filters.start && filters.end);

  useEffect(() => {
    if (!filters.branch_id || !filters.user_id) { setData(null); return; }
    const scope = {
      lang,
      ...(filters.branch_id !== "all" ? { branch_id: filters.branch_id } : {}),
      ...(filters.user_id !== "all" ? { user_id: filters.user_id } : {}),
    };
    (async () => {
      try {
        setData(custom
          ? await customSalaryReport({ start: filters.start, end: filters.end, ...scope })
          : await salaryReport({ month: filters.month, ...scope }));
      } catch {
        setData(null);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang, filters.month, filters.start, filters.end, filters.branch_id, filters.user_id]);

  return (
    <NeuCard data-testid="month-slips-card">
      <p className="label-xs">{t("payroll.slips", { month: filters.month })}</p>
      {data ? (
        <div className="mt-4"><SalaryDetails data={data} lang={lang} /></div>
      ) : (
        <p className="mt-4 text-sm text-muted-foreground" data-testid="month-slips-empty">
          {t("salaryReport.noData")}
        </p>
      )}
    </NeuCard>
  );
};
